<script>
    import IMask from "imask";
    import { onMount } from "svelte";
    export let formType = "sanatorium";

    let full_name = "";
    let phone_number = "";
    let email = "";
    let successMessage = "";
    let errorMessage = "";
    let maskInstance;

    onMount(() => {
        const element = document.getElementById("phone_number");
        maskInstance = IMask(element, {
            mask: "+{7}(000)000-00-00",
            lazy: false,
        });
    });

    const handleSubmit = async () => {
        errorMessage = "";
        successMessage = "";

        if (maskInstance) {
            phone_number = maskInstance.unmaskedValue;
        }

        if (!full_name || !phone_number || !email) {
            errorMessage = "Пожалуйста, заполните поля имени и email.";
            return;
        }

        if (!/^[+7]\d{10}$/.test(phone_number)) {
            errorMessage =
                "Некорректный номер телефона. Пожалуйста, введите корректный номер в формате +7XXXXXXXXXX.";
            return;
        }

        try {
            const response = await fetch("/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    full_name,
                    phone_number,
                    email,
                    formType,
                }),
            });

            if (response.ok) {
                successMessage =
                    "Данные успешно отправлены! Перенаправление на форму оплаты.";
                full_name = "";
                phone_number = "";
                email = "";
                window.location.href =
                    "https://auth.robokassa.ru/merchant/Invoice/TU5fsKMzt0uZtEZWcvseIg";
            } else {
                const errorData = await response.json();
                errorMessage = errorData.error || "Ошибка отправки данных.";
            }
        } catch (error) {
            errorMessage = "Ошибка сети. Пожалуйста, попробуйте позже.";
            console.error("Error:", error);
        }
    };
</script>

<div class="formBuy">
    <div class="logoUp">
        <img src="photo/Logo.jpg" class="logo" alt="logo" />
    </div>
    <p class="textUp">Перед покупкой заполните форму</p>
    {#if successMessage}
        <p style="color: green; text-align: center">{successMessage}</p>
    {/if}
    {#if errorMessage}
        <p style="color: red;">{errorMessage}</p>
    {/if}

    <form on:submit|preventDefault={handleSubmit} class="contact-form">
        <div class="form-group">
            <label for="full_name">Имя:</label>
            <input type="text" id="full_name" bind:value={full_name} required />
        </div>
        <div class="form-group">
            <label for="phone_number">Номер телефона:</label>
            <input type="tel" id="phone_number" />
        </div>
        <div class="form-group">
            <label for="email">Email:</label>
            <input type="email" id="email" bind:value={email} required />
        </div>
        <button type="submit">Перейти к оплате</button>
    </form>
</div>

<style>
    .formBuy {
        margin-top: 20px;
    }
    .logoUp {
        width: fit-content;
        margin: 0 auto;
        position: relative;
        margin-bottom: 10px;
    }
    .logo {
        width: 100px;
        margin: 0 auto;
    }
    .textUp {
        margin: 0 auto;
        font-size: 20px; /*Размер шрифта*/
        font-weight: 600;
        color: #4f7942;
        text-align: center;
    }

    form {
        margin-top: 20px;
        border-radius: 25px;
        padding: 100px 25px 100px 25px;
        background-color: #addfad;
        gap: 25px;
    }
    .contact-form {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 400px; /* Adjust as needed */
        margin: 20px auto;
    }
    .form-group {
        margin-bottom: 15px;
        color: #4f7942;
    }
    label {
        margin-bottom: 5px;
    }
    input[type="text"],
    input[type="tel"],
    input[type="email"] {
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        width: 100%;
    }
    button[type="submit"] {
        background-color: #4f7942;
        color: white;
        padding: 10px 15px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }
</style>
